
export default {
  props: {
    navData: {
      type: Array,
      default: () => [],
    },
    extraNavData: {
      type: Array,
      default: () => [],
    },
    miniVariant: {
      type: Boolean,
      default: false,
    },
    clipped: {
      type: Boolean,
      default: true,
    },
  },
}
